import React , {useState, useRef, useEffect} from "react";
import borderImage from "../../../assets/images/icons/buyers/border-buyers.svg"
import icon from "../../../assets/images/icons/buyers/image-buyers.svg"
import '../../../../src/index.css'
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import UserSuggestionsDropdown from "../../forms/buyersForm/userSuggestion";

const BuyerCardAdmin = ({
  user,
  y_position,
  onUserChange,
  height="h-[280px]",
  pt = true,
  onDelete,
  id,
  searchUsers,
  userSuggestions, 
  setUserSuggestions,
  options= "bottom-4",
  resetEditing = false,
  onImageError
}) => {

  const [isEditing, setIsEditing] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [nameError, setNameError] = useState("");
  const [chargeError, setChargeError] = useState("");

  const [showOptions, setShowOptions] = useState(false);
  const toggleOptions = () => setShowOptions(!showOptions);
  const fileInputRef = useRef(null);
  const showContactInfo = y_position !== 0 && y_position !== -1;
  const isDraggable = y_position <= -2;
  const [suggestionsKey, setSuggestionsKey] = useState(null);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id || user.id,
    data: {
      type: 'buyer',
      user,
    },
    disabled: !isDraggable  || user.y_position > -2 || isEditing
  });

  const [originalUserData, setOriginalUserData] = useState({
  name: '',
  email: '',
  contact_number: '',
  charge: '',
  image: ''
});
const style = {
  transform: CSS.Transform.toString(transform),
  transition,
    opacity: isDragging ? 0.8 : 1,
//    cursor: isDraggable && !isEditing ? 'grab' : 'default',
    position: 'relative',
    zIndex: isDragging ? 1000 : 'auto',
  boxShadow: isDragging ? '0 10px 25px rgba(0, 0, 0, 0.2)' : 'none'
};

useEffect(() => {
  if (isDragging) {
    document.body.style.cursor = 'grabbing';
    document.body.style.userSelect = 'none';
  } else {
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  }
  
  return () => {
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  };
}, [isDragging]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validImageTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp"
    ];

    if (!validImageTypes.includes(file.type)) {
      if (onImageError) {
        onImageError("Por favor, selecciona un archivo de imagen válido (JPG, JPEG, PNG o WEBP)");
      }
      e.target.value = "";
      return;
    }

    if (file.size > 50 * 1024 * 1024) {
      if (onImageError) {
        onImageError("La imagen no debe superar los 50MB");
      }
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      onUserChange({ ...user, image: reader.result });
    };
    reader.onerror = () => {
      if (onImageError) {
        onImageError("Error al leer el archivo de imagen");
      }
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (resetEditing) {
      setIsEditing(false);

    setEmailError("");
    setPhoneError("");
    setNameError("");
    setChargeError("");
    
    setShowOptions(false);
    
    if (suggestionsKey) {
      setUserSuggestions(prev => ({...prev, [suggestionsKey]: []}));
    }
    }
  }, [resetEditing]);
  
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    if (isEditing) {
      const key = `edit-${user.id}`;
      setSuggestionsKey(key);
      setUserSuggestions(prev => ({...prev, [key]: []}));
    }
  }, [isEditing, user.id, setUserSuggestions]);

const getTextColor = (field, isVisible) => {
  if (!isVisible) return 'text-[#B9B9B9]';
  
  switch(field) {
    case 'email':
      return 'text-[#111928]';
    case 'area':
      return 'text-[#769B40]';
    default:
      return 'text-[#184A7D]';
  }
};

useEffect(() => {
  const handleClickOutside = (event) => {
    if (showOptions && 
        !event.target.closest('.options-button') && 
        !event.target.closest('.options-menu')) {
      setShowOptions(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showOptions]);

  return (
    
    <div
      ref={setNodeRef}
      style={style}
      className={`relative flex flex-col w-[342px] items-center justify-start gap-1 p-2 px-8 text-center pt-10
        ${height} ${isDragging ? 'ring-2 ring-blue-500 shadow-lg' : ''}`}
      {...(isDraggable && !isEditing ? attributes : {})}
    >
{/** 
      {isDraggable && !isEditing && (   
        <div className="absolute z-10 p-2 rounded top-2 left-2 cursor-grab hover:bg-gray"
          {...attributes}
          {...listeners}
          onClick={(e) => e.stopPropagation()}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="#184A7D"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 6h2v2H8zm0 4h2v2H8zm0 4h2v2H8zm4-8h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm4-8h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2z" />
          </svg>
        </div>
      )}

*/}
      {/** IMAGEN */}
      <div className="pr-[10%]">
        <div className="relative">
          <img src={borderImage} alt="Borde" className="w-[101px] h-[101px]" />
          <div className="absolute inset-0 flex items-center justify-center">
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageChange}
              accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/jpg,image/png,image/webp"
              className="hidden"
            />
            {isEditing ? (
              // Subir imagen con ícono de lápiz
              <div onClick={triggerFileInput} className="relative cursor-pointer group">
                {user.image ? (
                  <>
                    <img 
                      src={user.image} 
                      alt={`Foto de ${user.name}`} 
                      className="w-[80px] rounded-full h-[80px] object-cover"
                    />
                    <div className="absolute inset-0 flex items-center justify-center transition-opacity duration-200 bg-black rounded-full opacity-100 bg-opacity-30">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="white"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                      >
                        <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" />
                      </svg>
                    </div>
                  </>
                ) : (
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="#184A7D"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                    >
                      <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" />
                    </svg>
                )}
              </div>
            ) : (
              // Imagen de comprador
              user.image ? (
                <img 
                  src={user.image} 
                  alt={`Foto de ${user.name}`} 
                  className="w-[80px] rounded-full h-[80px] object-cover"
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = icon;
                  }}
                />
              ) : (
                <img src={icon} alt="Icono por defecto" className="w-[80px] rounded-full h-[80px]" />
              )
            )}
          </div>
        </div>
      </div>
      {isEditing && (
      <div className="grid items-center justify-items-center justify-center w-full grid-cols-[90%_10%]">
        <p className="text-[10px] text-center text-gray font-itcbook">
          Formatos permitidos: JPG, JPEG, PNG, WEBP <br />
          Peso máx. 50 MB
        </p>
      </div>
      )}
      
      <div className="grid items-center justify-items-center justify-center w-full grid-cols-[90%_10%]">
        {/** NOMBRE */}
        {isEditing ? (
          <div className="relative w-[85%]">
            <input
              value={user.name}
              placeholder="Nombre completo *"
              onChange={(e) => {
                let value = e.target.value.replace(/[0-9]/g, "");

                onUserChange({ ...user, name: value });

                if (value.length > 50) {
                  setNameError("El nombre no puede exceder los 50 caracteres");
                  value = value.slice(0, 50);
                } else {
                  setNameError("");
                }
                
                if (suggestionsKey) {
                  searchUsers(value, suggestionsKey);
                }
              }}
              onKeyDown={(e) => /[0-9]/.test(e.key) && e.preventDefault()}
              maxLength={50}
              className={`rounded-lg h-[38px] outline-none w-full border-[1px] p-2 font-itcbook text-base text-center ${
                nameError ? 'border-red-500' : 'border-[#6B7280]'
              } bg-transparent`}
            />
            {nameError && (
              <p className="text-[10px] text-red-500 text-center mt-1">{nameError}</p>
            )}
            {userSuggestions[suggestionsKey]?.length > 0 && (
              <UserSuggestionsDropdown
                suggestions={userSuggestions[suggestionsKey]}
                onSelectUser={(selectedUser) => {
                  onUserChange({
                    ...user,
                    name: selectedUser.name,
                    email: selectedUser.email,
                    contact_number: selectedUser.contact_number,
                    charge: selectedUser.charge,
                    image: selectedUser.image
                  });
                  setUserSuggestions(prev => ({...prev, [suggestionsKey]: []}));
                  setNameError("");
                }}
                onClose={() => setUserSuggestions(prev => ({...prev, [suggestionsKey]: []}))}
              />
            )}
          </div>
        ) : (
          <p className={`${getTextColor('name', user.record_visibility)} font-itcdemi text-[18px]`}>
            {user.name && user.name.toLowerCase().split(' ').map(word => 
              word.charAt(0).toUpperCase() + word.slice(1)
            ).join(' ')}
          </p>
        )}

        {/**OPCIONES 3 puntos*/}
        <div className="flex items-center justify-center w-full">
          <div 
            className={`cursor-pointer w-6 h-6 rounded-full transition-colors duration-200 options-button 
              ${showOptions ? 'bg-[#E8F2F5] ' : ''
            }`}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              toggleOptions();
            }}
            onPointerDown={(e) => e.stopPropagation()} 
          >
            <svg onPointerDown={(e) => e.stopPropagation()}  className="relative z-10" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 7C11.4696 7 10.9609 6.78929 10.5858 6.41421C10.2107 6.03914 10 5.53043 10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C14 5.53043 13.7893 6.03914 13.4142 6.41421C13.0391 6.78929 12.5304 7 12 7ZM12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17C12.5304 17 13.0391 17.2107 13.4142 17.5858C13.7893 17.9609 14 18.4696 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21Z" fill="#184A7D"/>
            </svg>
  
            {showOptions && (
              <div className={`absolute z-10 right-4 ${isEditing ? "bottom-4" : "bottom-12"} options-menu`}>
                <div className="bg-[#184A7D] rounded-lg px-2 w-[42px] h-[113px] grid grid-rows-3 divide-y divide-white">
                  {/**OCULTAR */}

                  <button
                    className="flex items-center justify-center w-full h-full"
                    onClick={(e) => {
                      e.stopPropagation();
                      onUserChange({ 
                        ...user, 
                        record_visibility: !user.record_visibility 
                      });
                      setShowOptions(false); 
                    }}
                    >
                    {user.record_visibility ? (
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.886719 8.75C1.59172 4.91 4.95622 2 9.00022 2C13.0442 2 16.4087 4.91 17.1145 8.75C16.4095 12.59 13.0442 15.5 9.00022 15.5C4.95622 15.5 1.59172 12.59 0.886719 8.75ZM9.00022 12.5C9.99478 12.5 10.9486 12.1049 11.6519 11.4017C12.3551 10.6984 12.7502 9.74456 12.7502 8.75C12.7502 7.75544 12.3551 6.80161 11.6519 6.09835C10.9486 5.39509 9.99478 5 9.00022 5C8.00566 5 7.05183 5.39509 6.34857 6.09835C5.64531 6.80161 5.25022 7.75544 5.25022 8.75C5.25022 9.74456 5.64531 10.6984 6.34857 11.4017C7.05183 12.1049 8.00566 12.5 9.00022 12.5ZM9.00022 11C8.40348 11 7.83118 10.7629 7.40923 10.341C6.98727 9.91903 6.75022 9.34674 6.75022 8.75C6.75022 8.15326 6.98727 7.58097 7.40923 7.15901C7.83118 6.73705 8.40348 6.5 9.00022 6.5C9.59696 6.5 10.1693 6.73705 10.5912 7.15901C11.0132 7.58097 11.2502 8.15326 11.2502 8.75C11.2502 9.34674 11.0132 9.91903 10.5912 10.341C10.1693 10.7629 9.59696 11 9.00022 11Z" fill="white"/>
                    </svg>
                    ): (
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1877_28567)"><path d="M3.01342 3.95653L0.929419 1.87187L1.87209 0.929199L15.0714 14.1279L14.1288 15.0712L11.9221 12.8645C10.7494 13.6083 9.3888 14.0022 8.00009 13.9999C4.40542 13.9999 1.41475 11.4132 0.788086 7.99987C1.07536 6.44771 1.85581 5.02968 3.01342 3.95653ZM9.83875 10.7812L8.86275 9.8052C8.48945 9.98381 8.06994 10.0422 7.66204 9.97239C7.25414 9.90255 6.87796 9.70791 6.58533 9.41529C6.29271 9.12266 6.09807 8.74647 6.02823 8.33858C5.9584 7.93068 6.01681 7.51117 6.19542 7.13787L5.21942 6.16187C4.79523 6.80286 4.6056 7.57076 4.68264 8.33553C4.75968 9.1003 5.09865 9.81494 5.64217 10.3585C6.18568 10.902 6.90032 11.2409 7.66509 11.318C8.42986 11.395 9.19776 11.2054 9.83875 10.7812ZM5.31609 2.50653C6.14742 2.17987 7.05342 1.99987 8.00009 1.99987C11.5948 1.99987 14.5854 4.58653 15.2128 7.99987C15.0085 9.11054 14.5494 10.1587 13.8714 11.0619L11.2981 8.48853C11.3216 8.32853 11.3334 8.16564 11.3334 7.99987C11.3335 7.52083 11.2303 7.0474 11.0309 6.61184C10.8316 6.17627 10.5406 5.78879 10.178 5.47581C9.81532 5.16282 9.38947 4.93168 8.92943 4.79812C8.46939 4.66457 7.98596 4.63174 7.51209 4.70187L5.31609 2.50653Z" fill="white"/>
                    </g><defs><clipPath id="clip0_1877_28567"><rect width="18" height="18" fill="white"/></clipPath>
                    </defs>
                    </svg>
                    )
                    }
                  </button>

                  {/** EDITAR */}
                  <button
                    className="flex items-center justify-center w-full h-full"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOriginalUserData({
                        name: user.name,
                        email: user.email,
                        contact_number: user.contact_number,
                        charge: user.charge,
                        image: user.image
                      });
                      setIsEditing(true);
                    }}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                    </svg>
                  </button>
                  {/** ELIMINAR */}
                  <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowOptions(false);
                        onDelete(user.id); 
                      }}
                    className="flex items-center justify-center w-full h-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.241 4.00616L15.534 6.03516H19.5C19.6989 6.03516 19.8897 6.11417 20.0303 6.25483C20.171 6.39548 20.25 6.58624 20.25 6.78516C20.25 6.98407 20.171 7.17483 20.0303 7.31549C19.8897 7.45614 19.6989 7.53516 19.5 7.53516H18.731L17.858 17.7202C17.805 18.3402 17.762 18.8502 17.693 19.2622C17.623 19.6912 17.516 20.0752 17.307 20.4312C16.9788 20.9903 16.4909 21.4385 15.906 21.7182C15.534 21.8952 15.142 21.9682 14.708 22.0022C14.291 22.0352 13.78 22.0352 13.158 22.0352H10.842C10.22 22.0352 9.709 22.0352 9.292 22.0022C8.858 21.9682 8.466 21.8952 8.094 21.7182C7.50908 21.4385 7.02118 20.9903 6.693 20.4312C6.483 20.0752 6.378 19.6912 6.307 19.2622C6.238 18.8492 6.195 18.3402 6.142 17.7202L5.269 7.53516H4.5C4.30109 7.53516 4.11032 7.45614 3.96967 7.31549C3.82902 7.17483 3.75 6.98407 3.75 6.78516C3.75 6.58624 3.82902 6.39548 3.96967 6.25483C4.11032 6.11417 4.30109 6.03516 4.5 6.03516H8.466L8.759 4.00616L8.77 3.94516C8.952 3.15516 9.63 2.53516 10.48 2.53516H13.52C14.37 2.53516 15.048 3.15516 15.23 3.94516L15.241 4.00616ZM9.981 6.03516H14.018L13.762 4.25916C13.714 4.09216 13.592 4.03516 13.519 4.03516H10.481C10.408 4.03516 10.286 4.09216 10.238 4.25916L9.981 6.03516ZM11.25 10.7852C11.25 10.5862 11.171 10.3955 11.0303 10.2548C10.8897 10.1142 10.6989 10.0352 10.5 10.0352C10.3011 10.0352 10.1103 10.1142 9.96967 10.2548C9.82902 10.3955 9.75 10.5862 9.75 10.7852V15.7852C9.75 15.9841 9.82902 16.1748 9.96967 16.3155C10.1103 16.4561 10.3011 16.5352 10.5 16.5352C10.6989 16.5352 10.8897 16.4561 11.0303 16.3155C11.171 16.1748 11.25 15.9841 11.25 15.7852V10.7852ZM14.25 10.7852C14.25 10.5862 14.171 10.3955 14.0303 10.2548C13.8897 10.1142 13.6989 10.0352 13.5 10.0352C13.3011 10.0352 13.1103 10.1142 12.9697 10.2548C12.829 10.3955 12.75 10.5862 12.75 10.7852V15.7852C12.75 15.9841 12.829 16.1748 12.9697 16.3155C13.1103 16.4561 13.3011 16.5352 13.5 16.5352C13.6989 16.5352 13.8897 16.4561 14.0303 16.3155C14.171 16.1748 14.25 15.9841 14.25 15.7852V10.7852Z" fill="white"/>
                    </svg>
                  </button>

                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/**CARGO */}
      <div className="grid items-center justify-items-center justify-center w-full grid-cols-[90%_10%]">
        <div className="w-[85%]">
          {isEditing ? (
            <>
            <input
              value={user.charge}
              placeholder="Cargo"
              onChange={(e) => {
                let value = e.target.value.replace(/[0-9]/g, "");
  
                if (value.length > 50) {
                  setChargeError("El cargo no puede exceder los 50 caracteres");
                  value = value.slice(0, 50);
                } else {
                  setChargeError("");
                }
                onUserChange({ ...user, charge: value });
              }}
              onKeyDown={(e) => /[0-9]/.test(e.key) && e.preventDefault()}
              maxLength={50}
                className={`rounded-lg h-[38px] outline-none w-full border-[1px] p-2 font-itcbook text-base text-center ${
                  chargeError ? 'border-red-500' : 'border-[#6B7280]'
                } bg-transparent`}
            />
              {chargeError && (
                <p className="text-[10px] text-red-500 text-center mt-1">{chargeError}</p>
              )}
              </>
          ) : (
            <p className={`${getTextColor('charge', user.record_visibility)} font-itcbook text-[16px]`}>
              {user.charge}
            </p>
          )}
        </div>
      </div>

      {/**TELEFONO  */}
      {showContactInfo && (
      <div className="grid items-center justify-items-center justify-center w-full grid-cols-[90%_10%]">
          {isEditing ? (
            <div className="flex flex-col items-center justify-center w-full">
            <input
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="Número de contacto"
              value={user.contact_number}
                onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    
                    if (value.startsWith("0")) {
                        value = value.substring(1);
                    }
                    
                    value = value.slice(0, 9);
                    const processedValue = value === "" ? null : value;
                    onUserChange({ ...user, contact_number: processedValue });
                    
                    if (value.length === 0) {
                        setPhoneError("");
                    } else if (value.length < 9) {
                        setPhoneError("El número debe tener exactamente 9 dígitos");
                    } else {
                        setPhoneError("");
                    }
                }}
                onKeyDown={(e) => {
                    if (!/\d/.test(e.key) && 
                        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
                        e.preventDefault();
                    }
                }}
                className={`rounded-lg w-[85%] outline-none h-[38px] border-[1px] p-2 font-itcbook text-base text-center ${
                  phoneError ? "border-red-500" : "border-[#6B7280]"
                } bg-transparent`}
            />
            {phoneError && (
              <p className="text-[10px] text-red-500">{phoneError}</p>
            )}
            </div>
          ) : (
          <p className={`font-itcmedium text-[13px] ${user.visibility_contact_number ? getTextColor('contact', user.record_visibility) : 'text-[#B9B9B9]'}`}>
            {user.contact_number}
          </p>
          )}
          
          <button
            onClick={(e) => {
              e.stopPropagation();
              onUserChange({ ...user, visibility_contact_number: !user.visibility_contact_number })}
            }
          >
            {user.visibility_contact_number ? (
            <div className="flex items-center justify-center w-full">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.788086 7.77783C1.41475 4.3645 4.40542 1.77783 8.00009 1.77783C11.5948 1.77783 14.5854 4.3645 15.2128 7.77783C14.5861 11.1912 11.5948 13.7778 8.00009 13.7778C4.40542 13.7778 1.41475 11.1912 0.788086 7.77783ZM8.00009 11.1112C8.88414 11.1112 9.73199 10.76 10.3571 10.1349C10.9822 9.50973 11.3334 8.66189 11.3334 7.77783C11.3334 6.89378 10.9822 6.04593 10.3571 5.42081C9.73199 4.79569 8.88414 4.4445 8.00009 4.4445C7.11603 4.4445 6.26818 4.79569 5.64306 5.42081C5.01794 6.04593 4.66675 6.89378 4.66675 7.77783C4.66675 8.66189 5.01794 9.50973 5.64306 10.1349C6.26818 10.76 7.11603 11.1112 8.00009 11.1112ZM8.00009 9.77783C7.46965 9.77783 6.96095 9.56712 6.58587 9.19205C6.2108 8.81697 6.00009 8.30827 6.00009 7.77783C6.00009 7.2474 6.2108 6.73869 6.58587 6.36362C6.96095 5.98855 7.46965 5.77783 8.00009 5.77783C8.53052 5.77783 9.03923 5.98855 9.4143 6.36362C9.78937 6.73869 10.0001 7.2474 10.0001 7.77783C10.0001 8.30827 9.78937 8.81697 9.4143 9.19205C9.03923 9.56712 8.53052 9.77783 8.00009 9.77783Z" fill="#184A7D"/>
              </svg>
            </div>
            ) : (
              <div className="flex items-center justify-center w-full">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1877_28567)"><path d="M3.01342 3.95653L0.929419 1.87187L1.87209 0.929199L15.0714 14.1279L14.1288 15.0712L11.9221 12.8645C10.7494 13.6083 9.3888 14.0022 8.00009 13.9999C4.40542 13.9999 1.41475 11.4132 0.788086 7.99987C1.07536 6.44771 1.85581 5.02968 3.01342 3.95653ZM9.83875 10.7812L8.86275 9.8052C8.48945 9.98381 8.06994 10.0422 7.66204 9.97239C7.25414 9.90255 6.87796 9.70791 6.58533 9.41529C6.29271 9.12266 6.09807 8.74647 6.02823 8.33858C5.9584 7.93068 6.01681 7.51117 6.19542 7.13787L5.21942 6.16187C4.79523 6.80286 4.6056 7.57076 4.68264 8.33553C4.75968 9.1003 5.09865 9.81494 5.64217 10.3585C6.18568 10.902 6.90032 11.2409 7.66509 11.318C8.42986 11.395 9.19776 11.2054 9.83875 10.7812ZM5.31609 2.50653C6.14742 2.17987 7.05342 1.99987 8.00009 1.99987C11.5948 1.99987 14.5854 4.58653 15.2128 7.99987C15.0085 9.11054 14.5494 10.1587 13.8714 11.0619L11.2981 8.48853C11.3216 8.32853 11.3334 8.16564 11.3334 7.99987C11.3335 7.52083 11.2303 7.0474 11.0309 6.61184C10.8316 6.17627 10.5406 5.78879 10.178 5.47581C9.81532 5.16282 9.38947 4.93168 8.92943 4.79812C8.46939 4.66457 7.98596 4.63174 7.51209 4.70187L5.31609 2.50653Z" fill="#184A7D"/>
                </g><defs><clipPath id="clip0_1877_28567"><rect width="16" height="16" fill="white"/></clipPath>
                </defs>
                </svg>
              </div>
            )}
          </button>
      </div>
      )}

      {/** EMAIL */}
      {showContactInfo && (
      <div className="grid items-center justify-items-center justify-center w-full grid-cols-[90%_10%]">
          {isEditing ? (
            <div className="flex flex-col items-center justify-center w-full">
            <input
              type="email"
              placeholder="Correo electrónico *"
              value={user.email}
              className={`rounded-lg w-[85%] outline-none h-[38px] border-[1px] p-2 font-itcbook text-base text-center ${
                  emailError ? "border-red-500" : "border-[#6B7280]"
              } bg-transparent`}
              onChange={(e) => {
                let value = e.target.value.trim();
                
                if (value.length > 200) {
                  setEmailError("El correo no puede exceder los 200 caracteres");
                  value = value.slice(0, 200);
                } else if (value === "") {
                  setEmailError("");
                } else if (!/^[A-Za-z0-9._%+-]+@tasa\.com\.pe$/i.test(value)) {
                  setEmailError("Solo se permiten correos con dominio @tasa.com.pe");
                } else {
                  setEmailError("");
                }
                
                onUserChange({ ...user, email: value });
              }}
              maxLength={200}
            />
              {emailError && (
                <p className="text-[10px] text-red-500">{emailError}</p>
              )}
              </div>
          ) : (
          <a 
            href={`mailto:${user.email}`} 
            className={`font-itcbook ${user.visibility_email ? getTextColor('email', user.record_visibility) : 'text-[#B9B9B9]'} text-[14px] underline text-center break-words w-full`}
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}
            title={user.email.toLowerCase()}
          >
             {user.email.toLowerCase()}
          </a>
          )}
          <button
            onClick={(e) => {
              e.stopPropagation();
              onUserChange({ ...user, visibility_email: !user.visibility_email })}
            }
          >
            {user.visibility_email ? (
              <div className="flex items-center justify-center w-full">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.788086 7.77783C1.41475 4.3645 4.40542 1.77783 8.00009 1.77783C11.5948 1.77783 14.5854 4.3645 15.2128 7.77783C14.5861 11.1912 11.5948 13.7778 8.00009 13.7778C4.40542 13.7778 1.41475 11.1912 0.788086 7.77783ZM8.00009 11.1112C8.88414 11.1112 9.73199 10.76 10.3571 10.1349C10.9822 9.50973 11.3334 8.66189 11.3334 7.77783C11.3334 6.89378 10.9822 6.04593 10.3571 5.42081C9.73199 4.79569 8.88414 4.4445 8.00009 4.4445C7.11603 4.4445 6.26818 4.79569 5.64306 5.42081C5.01794 6.04593 4.66675 6.89378 4.66675 7.77783C4.66675 8.66189 5.01794 9.50973 5.64306 10.1349C6.26818 10.76 7.11603 11.1112 8.00009 11.1112ZM8.00009 9.77783C7.46965 9.77783 6.96095 9.56712 6.58587 9.19205C6.2108 8.81697 6.00009 8.30827 6.00009 7.77783C6.00009 7.2474 6.2108 6.73869 6.58587 6.36362C6.96095 5.98855 7.46965 5.77783 8.00009 5.77783C8.53052 5.77783 9.03923 5.98855 9.4143 6.36362C9.78937 6.73869 10.0001 7.2474 10.0001 7.77783C10.0001 8.30827 9.78937 8.81697 9.4143 9.19205C9.03923 9.56712 8.53052 9.77783 8.00009 9.77783Z" fill="#184A7D"/>
            </svg>
          </div>
            ) : (
              <div className="flex items-center justify-center w-full">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1877_28567)">
                <path d="M3.01342 3.95653L0.929419 1.87187L1.87209 0.929199L15.0714 14.1279L14.1288 15.0712L11.9221 12.8645C10.7494 13.6083 9.3888 14.0022 8.00009 13.9999C4.40542 13.9999 1.41475 11.4132 0.788086 7.99987C1.07536 6.44771 1.85581 5.02968 3.01342 3.95653ZM9.83875 10.7812L8.86275 9.8052C8.48945 9.98381 8.06994 10.0422 7.66204 9.97239C7.25414 9.90255 6.87796 9.70791 6.58533 9.41529C6.29271 9.12266 6.09807 8.74647 6.02823 8.33858C5.9584 7.93068 6.01681 7.51117 6.19542 7.13787L5.21942 6.16187C4.79523 6.80286 4.6056 7.57076 4.68264 8.33553C4.75968 9.1003 5.09865 9.81494 5.64217 10.3585C6.18568 10.902 6.90032 11.2409 7.66509 11.318C8.42986 11.395 9.19776 11.2054 9.83875 10.7812ZM5.31609 2.50653C6.14742 2.17987 7.05342 1.99987 8.00009 1.99987C11.5948 1.99987 14.5854 4.58653 15.2128 7.99987C15.0085 9.11054 14.5494 10.1587 13.8714 11.0619L11.2981 8.48853C11.3216 8.32853 11.3334 8.16564 11.3334 7.99987C11.3335 7.52083 11.2303 7.0474 11.0309 6.61184C10.8316 6.17627 10.5406 5.78879 10.178 5.47581C9.81532 5.16282 9.38947 4.93168 8.92943 4.79812C8.46939 4.66457 7.98596 4.63174 7.51209 4.70187L5.31609 2.50653Z" fill="#184A7D"/>
                </g>
                <defs>
                <clipPath id="clip0_1877_28567">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
                </defs>
                </svg>

              </div>
            )}
          </button>
      </div>
      )}

      {/** ÁREA */}
      <div className="grid items-center justify-items-center justify-center w-full grid-cols-[90%_10%]">
        <p className={`font-itcmedium text-[13px] break-words ${getTextColor('area', user.record_visibility)}`}>
            {user.area_name}
        </p>
      </div>


    </div>

  );
};

export default BuyerCardAdmin;